import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import { loginAction } from "../network/store/action/UserResponseAction";
import { useDispatch, useSelector } from "react-redux";
import { changeStatus, loadingStatus } from "../redux/slice/loaderSlice";
import AppToast from "../components/appToast";
import { updateMessage } from "../redux/slice/toastSlice";
import AppLodingBar from "../components/loader";
import logo from "../assets/eatnewlogo.png";
import { useIsEmployee  } from "../utils/userRoles";
import { consoleLog } from "../utils/log-utils";
import { staffLogin } from "../network/service/PlatformAuth";

/**
 *
 * @returns Login Component
 */
const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector(loadingStatus);
  const isEmployee=useIsEmployee();

  // user login form
  const [requestForm, setRequestForm] = useState({
    userName: "",
    password: "",
  });

  useEffect(()=>{
    dispatch(changeStatus(false));
  },[])

  const handleChanges = (e) => {
    setRequestForm({ ...requestForm, [e.target.name]: e.target.value });
  };

  const login = async () => {
    
    dispatch(changeStatus(true));
    let requestObject = {
      username: requestForm.userName,
      password: requestForm.password,
     
    };

    await dispatch(loginAction(requestObject, useDispatch)).then((response) => {
      dispatch(changeStatus(false));

      if (response.status) {
        consoleLog(" response.responseCode", response.responseCode)

        // Same credentials unlock the new platform (nutrition & health grades).
        // Not awaited: the admin panel works without it, and the nutrition
        // screens say why if it failed.
        staffLogin(requestObject.username, requestObject.password).catch((error) =>
          consoleLog("Nutrition service sign-in failed", error.message),
        );

       
        isEmployee?dispatch(
          updateMessage({
            display: true,
            message: "No Access",
          })
        )
        :navigate("/dashboard");
      } else {
        dispatch(
          updateMessage({
            display: true,
            message: response.serverFailed
              ? "Server is not responding. Please try again later."
              : "Invalid username or Password",
          })
        );
       }
    });
  };

  return (
    <>
      {isLoading && <AppLodingBar />}
      {/* login-bg */}
      <div className="login-page">
        <div className="row">
          <div className="login card-1">
            <div>
              <h3 className="text-centers" style={{ color: "#fff" }}>
                <img src={logo} alt="" width="100%" />
              </h3>
            </div>
            <div>
              <div className="form-group">
                <label htmlFor="form2Example11">User Name</label>
                <input
                  type="email"
                  name="userName"
                  value={requestForm.userName}
                  onChange={(e) => handleChanges(e)}
                  id="form2Example11"
                  className="form-control"
                  placeholder="Enter email/Mobile number"
                />
              </div>
              <div className="form-group">
                <label htmlFor="form2Example22">Password</label>
                <input
                  type="password"
                  name="password"
                  value={requestForm.password}
                  onChange={(e) => handleChanges(e)}
                  id="form2Example22"
                  className="form-control"
                  placeholder="Enter Password"
                />
              </div>
            </div>
            <div>
              <button
                className="btn w-100 text-center"
                onClick={(e) => login(e)}
              >
                LOGIN
              </button>
              <Link to="/nutritionist-login" className="login-switch">
                Nutrition expert? Sign in here
              </Link>
            </div>
          </div>
        </div>
      </div>

      <AppToast />
    </>
  );
};

export default Login;
